// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__nx6YY","right":"styles_right__1U4QX"};